var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPetAnjoUserCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D8EEF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M32 13.667c-10.127 0-18.333 8.205-18.333 18.333 0 10.128 8.206 18.333 18.333 18.333 10.128 0 18.334-8.205 18.334-18.333 0-10.128-8.206-18.333-18.334-18.333zm0 7.096a6.505 6.505 0 110 13.011 6.505 6.505 0 010-13.01zm0 25.43a14.167 14.167 0 01-10.83-5.041c1.39-2.617 4.11-4.42 7.282-4.42.178 0 .355.028.525.08 1.958.68 4.088.68 6.047 0 .17-.052.347-.08.525-.08 3.171 0 5.892 1.803 7.281 4.42A14.165 14.165 0 0132 46.194z",
    fill: "#028BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 33.774a6.505 6.505 0 100-13.01 6.505 6.505 0 000 13.01zm3.548 2.957a1.828 1.828 0 00-.525.081 9.216 9.216 0 01-6.047 0 1.828 1.828 0 00-.524-.08c-3.172 0-5.892 1.803-7.282 4.42 5.032 5.981 13.96 6.75 19.941 1.719a14.193 14.193 0 001.719-1.72c-1.39-2.616-4.11-4.42-7.282-4.42z",
    fill: "#028BB7"
  })));
}

export default SvgPetAnjoUserCircle;